<template>
  <div class="wxAddress">
    <div class="wxAddress_title">
      关联微信
    </div>
    <div>
      <div id="wxImg">
        <img :src="'data:image/png;base64,' + wxImgSrc" alt="微信二维码" />
        <div class="upBox" v-if="wxUp" @click="wxRefresh">
          <span>二维码失效，请刷新页面</span>
        </div>
      </div>
    </div>
    <div class="loadingIcon" v-show="loadingIcon"><i class="el-icon-loading"></i>&nbsp;登录中</div>
    <div class="ignore" @click="goLogin">跳过</div>
  </div>
</template>
<script>
import md5 from "js-md5";
export default {
  name: "wxAddress",
  props: {
    params: {
      type: Object,
    }
  },
  watch: {
    params: {
      handler (newName, oldName) {
        let _this = this

        if (newName) {
          _this.userInfo = newName.userInfo
          _this.getWX(_this.userInfo.id)
        }

      },
      deep: true,
      immediate: true
    }
  },
  data () {
    return {
      loadingIcon: false,
      wxUp: false,
      wxImgSrc: "",
      wxState: "",
      userInfo: "",
    };
  },
  created () {
    let _this = this
    // if (this.$route.query.userInfo) {
    //   //   JSON.parse(this.$route.query.userInfo)
    //   this.userInfo = JSON.parse(_this.$Base64.decode(_this.$route.query.userInfo))
    //   this.getWX(this.userInfo.id)

    // }

  },
  beforeDestroy () {
    clearInterval(this.wxInter);
  },
  methods: {
    // 刷新页面
    wxRefresh () {
      this.$router.go(0);
    },
    //去登录
    goLogin () {
      let that = this
      let params = {}
      console.log(this.userInfo)
      if (this.userInfo.loginPhone) {
        params = {
          loginName: this.userInfo.loginPhone,
          password: md5(this.userInfo.pwd), //password
          platformType: 0
        }
      } else {
        params = {
          loginName: this.userInfo.email,
          password: md5(this.userInfo.pwd), //password
          platformType: 0
        }
      }

      this.catReq1Service("/user/login", params).then(function (response) {
        if (response.resultCode === "1") {
          let data = response.result;
          let val = JSON.stringify(data);
          // localStorage.setItem("myId", data.id);
          localStorage.setItem("myUser", val);
          localStorage.setItem("myUserImg", data.avatar); // 头像
          localStorage.setItem("myUserName", data.nickName); // 昵称
          localStorage.setItem("myAliasName", data.aliasName); // 别名
          localStorage.setItem("myPhone", data.loginPhone); // 电话
          localStorage.setItem("openid", data.openid); // 电话
          localStorage.setItem("myEmail", data.email); // 邮箱
          localStorage.setItem("myCompanyCode", data.selfCompany.code); // 公司编码
          // that.$router.push({ name: "home" }); // 跳到首页

          that.$router.replace({ name: "home" }); // 跳到首页
        }
      });
      // this.$router.push({ name: "login_in", params: { isShow: true } })
    },
    /// 轮询 是否扫二维码
    getWXStatus () {
      var that = this;
      this.catReq1Service(
        "/wechat/get_openId",
        { state: this.wxState },
        "post",
        2
      ).then(function (response) {
        if (response.resultCode == "0") {
          that.wxUp = true;
          clearInterval(that.wxInter);
          return;
        }
        let data = response.result;
        if (data != null) {
          if (data.resultCode === "0") {
            clearInterval(that.wxInter);
            if (data.errorDesc === "用户无权登陆") {
              that.$message.closeAll();
              that.$message({
                message: "暂无登录权限，请联系管理员。或飞译官方客服：13717630007",
                type: "warning"
              });
              that.getWX(that.userInfo.id);
              return
            }
            that.wxUp = true;
          } else {
            if (data.result.openId == "false") {
              that.$message.closeAll();
              that.$message({
                showClose: true,
                message: "该微信已绑定过用户，无法重复绑定。",
                type: "warning"
              });
              that.getWX(that.userInfo.id);
              return
            } else {
              clearInterval(that.wxInter);
              that.wxLogin(data.result.openId);
            }

          }
        }
      });
      // }, 1000);
      // console.log(this.wxState,"this.wxState")
    },
    // 获取二维码
    async getWX (id) {
      let that = this;
      this.isShow = true;
      let params = {
        userId: id,
      }
      const res = await this.catReq1Service("/wechat/get_bind_weChat_login_url", params, "get")
      this.wxImgSrc = res.result.urlBase64;
      this.wxState = res.result.state;
      that.wxInter = window.setInterval(that.getWXStatus, 1000);
    },
    // 二维码登录
    wxLogin (data) {
      localStorage.setItem("openid", data);
      let that = this;
      this.loadingIcon = true;
      let platformType = this.nodeName === "drill" ? 5 : undefined;
      this.catReq1Service("/user/loginByOpenId", { openId: data, platformType }).then(
        function (response) {
          if (response.resultCode === "1") {
            let data = response.result;
            let val = JSON.stringify(data);
            localStorage.setItem("myUser", val);
            localStorage.setItem("myPhone", data.loginPhone); // 电话
            localStorage.setItem("myId", data.selfCompany.id);
            localStorage.setItem("myUserImg", data.avatar); // 头像
            localStorage.setItem("myUserName", data.nickName); // 昵称
            localStorage.setItem("myAliasName", data.aliasName); // 别名  --
            localStorage.setItem("myCompanyCode", data.selfCompany.code); // 公司编码
            that.$router.replace({ name: "home" }); // 跳到首页
          }
        }
      );
    },
  },
};
</script>
<style lang="less" scoped>
.wxAddress {
  width: 284px;
  height: 370px;
  // background: rgba(255, 255, 255, 1);
  // box-shadow: 0px 10px 10px 0px rgba(137, 137, 137, 0.13);
  border-radius: 10px;
  // padding: 50px;
  padding: 0px 80px 0 80px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  .wxAddress_title {
    text-align: center;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    margin-bottom: 40px;
    color: rgba(0, 0, 0, 1);
  }
  #wxImg {
    width: 254px;
    height: 254px;
    border: 1px solid;
    border-radius: 4px;
    margin: 0 auto;
    position: relative;

    .upBox {
      position: absolute;
      width: 97%;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      height: 97%;
      background: rgba(255, 255, 255, 0.9);
      z-index: 50;
      cursor: pointer;
      font-weight: 600;
      span {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
    }
    img {
      // width: 100%;
      // height: 100%;
      // border: 1px solid #999999;
      // border-radius: 4px;
      position: relative;
      top: 50%;
      transform: translateY(-50%);
      margin-bottom: 20px;
    }
    span {
      font-size: 18px;
      width: 100%;
      text-align: center;
    }
    i {
      font-size: 20px;
    }
  }
  .loadingIcon {
    margin-top: 3px;
    text-align: center;
  }
  .ignore {
    margin-top: 15px;
    height: 12px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: rgba(69, 69, 69, 1);
    margin-left: 15px;
    cursor: pointer;
  }
}
</style>

